"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StartAtInput = void 0;
const react_1 = __importDefault(require("react"));
const react_input_mask_1 = __importDefault(require("react-input-mask"));
const core_1 = require("@material-ui/core");
const shared_spaced_group_1 = require("@guidde-co/shared.spaced-group");
const StartAtInput = ({ setStartTime, startAt, startTime }) => (react_1.default.createElement(shared_spaced_group_1.SpacedGroup, null,
    react_1.default.createElement(core_1.FormControlLabel, { control: react_1.default.createElement(core_1.Checkbox, { checked: startAt.isTrue, color: "primary", onChange: (e, val) => startAt.set(val), name: "checkedA" }), label: react_1.default.createElement(core_1.Typography, { color: "textSecondary" }, "Start at") }),
    startAt.isTrue && (react_1.default.createElement(react_input_mask_1.default, { mask: "99:99:99", maskPlaceholder: "-", placeholder: "00:00:00", value: startTime, onChange: event => setStartTime(event.target.value) },
        react_1.default.createElement(core_1.TextField, { style: { width: '70px' }, size: "small", inputProps: {
                style: {
                    background: '#FFFFFF',
                    textAlign: 'center',
                    borderRadius: '4px 4px 0 0',
                    color: 'rgba(0, 0, 0, 0.54)'
                }
            } })))));
exports.StartAtInput = StartAtInput;
//# sourceMappingURL=StartAtInput.js.map